export default "__VITE_ASSET__1e513e59__"